<template>
  <div class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img
        src="@/assets/jiejue/custom/equal-solution-hero-banner.svg"
        alt=""
        srcset=""
        style="width: 100%"
        @load="loaded = true"
        :class="{ show: loaded }"
        class="top_img"
      />
      <div class="ai-hero-title">中小系统低成本安全解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a
        class="product-tab"
        :class="{ active: activeTab === 'background' }"
        href="#background"
        @click.prevent="scrollTo('background')"
        >需求背景</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'challenges' }"
        href="#challenges"
        @click.prevent="scrollTo('challenges')"
        >业务挑战</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'scenarios' }"
        href="#scenarios"
        @click.prevent="scrollTo('scenarios')"
        >场景应用</a
      >
      <a
        v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
        class="product-tab"
        :class="{ active: activeTab === 'architecture' }"
        href="#architecture"
        @click.prevent="scrollTo('architecture')"
        >部署示意图</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'advantages' }"
        href="#advantages"
        @click.prevent="scrollTo('advantages')"
        >方案优势</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'cases' }"
        href="#cases"
        @click.prevent="scrollTo('cases')"
        >典型案例</a
      >
    </nav>

    <div class="product-body">
    <section
      id="background"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': backgroundVisible }"
    >
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            中小系统低成本是专为满足网络安全等级保护合规需求设计的集成化安全设备，核心功能涵盖安全防护、风险管控、审计追溯与合规适配等多个维度。它整合了防火墙、入侵检测 / 防御、病毒防护、漏洞扫描、资产梳理等基础安全能力，可精准抵御网络攻击、恶意代码等外部威胁；同时具备全面的日志采集、存储与分析功能，能完整记录网络行为、设备操作等关键信息，满足等保审计要求，帮助政企单位高效落实等保合规要求，筑牢网络安全防线。
          </p>
        </div>
      </div>
    </section>

    <section
      id="challenges"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': challengesVisible }"
    >
      <div class="section-title">业务挑战</div>
      <div class="section-content">
      <div class="grid-2">
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/equal-protection/p1.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">政策层面</div>
            <div class="card-desc">
              重要业务系统需要按照网络安全等级保护的要求进行定级、备案、整改、测评，满足网络安全等级保护要求。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/equal-protection/p2.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">安全层面</div>
            <div class="card-desc">
              业务系统在网络、计算环境、应用等方面面临网络安全攻击风险，需提高业务安全防护等级。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/equal-protection/p3.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">运维管理</div>
            <div class="card-desc">
              传统单台分散设备造成运维困难，运维成本增高，排查故障效率低下等问题。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/equal-protection/p4.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">建设成本高</div>
            <div class="card-desc">
              要满足等级保护二级和三级的合规要求，需要多台单独硬件安全设备，增加了客户的建设成本。
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="scenarios"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': scenariosVisible }"
    >
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <div class="scenario-item">
            <!-- <div class="item-title">数据处理与分析场景</div> -->
            <div class="item-desc">
              传统的安全建设解决方案，基于客户等级保护测评定级的需求以及安全防护的立体层次需求，提供不同类型设备的组合方案，帮助客户实现安全建设。这种多设备组合的方案，虽可以满足测评定级的需求以及安全防护的需求，然而对客户现有的网络结构、业务系统架构与扩展、运维管理都提出更大的挑战，用户无法快速、高效完成等级保护建设。
            </div>
          </div>
        </div>
        <!-- <div class="scenario-image" aria-label="AI 芯片示意图"></div> -->
        <img
          src="@/assets/jiejue/equal-protection/right.svg"
          alt=""
          style="width: 50%; border-radius: 4px"
          class="mobile-hidden-img"
        />
      </div>
      </div>
    </section>

    <section
      v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
      id="architecture"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': architectureVisible }"
    >
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img src="@/assets/solutions/deploy/equal-protection.svg" alt="部署示意图" class="architecture-image" />
      </div>
    </section>

    <section
      id="advantages"
      class="product-section section-row advantages ai-platform-block"
      :class="{ 'animate-in': advantagesVisible }"
    >
      <div class="section-title">方案优势</div>
      <div class="section-content">
      <div class="grid-4">
        <div class="adv-card">
          <!-- <div class="adv-badge">1</div> -->
          <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge" />
          <div class="adv-title">软硬件一体、快速合规</div>
          <div class="adv-desc">
            等保一体机采用一体机形态软件层面预植等保 2.0 二级 /
            三级合规能力模块，无需额外搭配第三方软件，开箱后仅需简单部署，即可快速满足等保要求，大幅缩短合规测评准备周期，同时避免软硬件拆分部署导致的合规漏洞与性能损耗
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge" />
          <div class="adv-title">灵活扩展、按需选择</div>
          <div class="adv-desc">
            等保一体机基于模块化设计，用户可根据自身业务规模、数据敏感等级及目标等保级别（二级
            /
            三级），灵活选择所需模块组合，从小型企业的基础合规需求，到中大型组织的深度防护诉求均可精准适，实现
            “按需部署、弹性扩展” 的等保建设模式
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge" />
          <div class="adv-title">统一管理、安全闭环</div>
          <div class="adv-desc">
            等保一体机搭载统一可视化统一云安全管理平台，支持集中管控设备配置、合规策略、日志分析、告警响应等全流程操作，无需分散管理多台独立安全设备，确保合规状态全程可视、可控
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge" />
          <div class="adv-title">简化操作、高效运维</div>
          <div class="adv-desc">
            等保一体机优化了可视化操作界面，将复杂的等保配置流程转化为向导式操作，可通过统一平台集中维护多台一体机的配置，大幅降低跨地域运维成本，            既避免合规配置误操作风险，又提升等保合规的持续性与运维效率
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="cases"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': casesVisible }"
    >
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某省电视台作为省级重要媒体单位，承担着新闻宣传、文化传播等重要职能，其业务系统涵盖新闻采编、节目播出、新媒体发布等多个环节，涉及大量敏感信息和核心数据。根据网络安全等级保护2.0标准要求，该电视台的核心业务系统需达到等保三级合规水平。当前，电视台面临的问题是：现有安全设备分散，涵盖防火墙、审计、漏洞扫描等多种设备，运维管理复杂，需投入大量人力进行维护；安全能力缺失，部分等保要求的安全审计、基线管理等能力不足，无法满足等保三级测评要求；等保建设周期紧、预算有限，无法进行大规模的安全设备采购和部署；缺乏统一的安全管控平台，安全威胁无法实现可视化、可追溯。为快速完成等保合规建设，提升安全防护水平，电视台引入等保一体机解决方案。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 合规整改周期紧：需在短期内完成等保三级合规建设，确保顺利通过测评，现有分散的安全设备难以快速适配等保要求；</li>
              <li>2. 运维管理难度大：多种安全设备独立运行，策略配置、日志管理、漏洞修复需分别操作，运维效率低，且易出现策略冲突；</li>
              <li>3. 安全能力不完整：缺乏等保三级要求的安全审计、基线管理、漏洞扫描等能力，需补全安全体系；</li>
              <li>4. 成本控制严格：预算有限，无法单独采购多种安全设备，需在控制成本的前提下，实现全方位的合规防护。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 一体化交付，快速满足合规需求：部署云翼等保一体机，将下一代防火墙、WAF、负载均衡、网络审计、数据库审计、日志审计、堡垒机、基线管理、漏洞扫描等多种安全网元整合一体，内置等保三级合规套餐，一键开通即可实现全方位安全防护，快速适配等保2.0标准，大幅缩短合规整改周期。</li>
              <li>2. 统一管控，简化运维管理：通过一体机的统一安全管理平台，实现所有安全网元的集中管控，统一下发安全策略、集中编排安全网元、全局制定预警策略，无需分别操作多种设备，大幅提升运维效率，避免策略冲突。</li>
              <li>3. 补全安全能力，构建纵深防御：借助一体机内置的安全组件，补全等保三级要求的安全审计、基线管理、漏洞扫描等能力，实现从边界防护、主机防护到安全审计的全流程防护，有效应对各类网络威胁。</li>
              <li>4. 降低综合成本：一体机采用一体化设计，无需单独采购多种安全设备，节约机房空间和硬件投入；同时简化运维流程，减少运维人力成本，实现绿色IT和便捷管理，在预算范围内完成等保建设。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from "@/data/solutionUi.js";
;
import equalSolutionHeroBanner from "@/assets/jiejue/custom/equal-solution-hero-banner.svg";

const loaded = ref(false);

const backgroundVisible = ref(false);
const challengesVisible = ref(false);
const scenariosVisible = ref(false);
const architectureVisible = ref(false);
const advantagesVisible = ref(false);
const casesVisible = ref(false);

// 这里写即可，代替 export default
defineOptions({
  banner: equalSolutionHeroBanner,
});

// 添加navObserver引用
const navObserver = ref(null);
const animationObserver = ref(null);
const isScrollingProgrammatically = ref(false); // 添加标志，防止程序滚动时覆盖activeTab

const activeTab = ref("background");
const scrollTo = async (id) => {
  const el = document.getElementById(id);
  if (!el) return;

  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id;
  history.replaceState(null, "", `#${id}`);

  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true;

  // 使用nextTick确保DOM更新后再滚动
  await nextTick();

  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    const stickyOffset = 120;
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  // 滚动完成后，重置标志，允许IntersectionObserver再次工作
  setTimeout(() => {
    isScrollingProgrammatically.value = false;
    // 确保滚动结束后activeTab是正确的
    updateActiveTab();
  }, 800); // 增加延迟，确保滚动完全结束
};

const updateActiveTab = () => {
  const sections = ["background", "challenges", "scenarios", "architecture", "advantages", "cases"];
  const scrollPosition = window.scrollY + 150; // 考虑sticky导航的高度

  for (let i = sections.length - 1; i >= 0; i--) {
    const section = document.getElementById(sections[i]);
    if (section) {
      const { top } = section.getBoundingClientRect();
      const absoluteTop = top + window.scrollY;

      if (absoluteTop <= scrollPosition) {
        if (activeTab.value !== sections[i]) {
          activeTab.value = sections[i];
          history.replaceState(null, "", `#${sections[i]}`);
        }
        break;
      }
    }
  }
};

// 防抖函数
const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

// 处理滚动事件的函数
const handleScroll = debounce(() => {
  // 如果是程序触发的滚动，不更新activeTab
  if (isScrollingProgrammatically.value) return;

  updateActiveTab();
}, 100);

// 立即处理的滚动函数（不防抖）
const handleScrollImmediate = () => {
  // 如果是程序触发的滚动，不更新activeTab
  if (isScrollingProgrammatically.value) return;

  updateActiveTab();
};

// 设置IntersectionObserver来检测当前可见的区块
const setupIntersectionObserver = () => {
  // 清理之前的观察器
  if (navObserver.value) {
    navObserver.value.disconnect();
  }

  // 创建新的观察器
  navObserver.value = new IntersectionObserver(
    (entries) => {
      // 如果是程序触发的滚动，暂时不更新activeTab
      if (isScrollingProgrammatically.value) return;

      // 找到可见度最高的元素
      let maxEntry = null;
      let maxRatio = 0;

      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
          maxRatio = entry.intersectionRatio;
          maxEntry = entry;
        }
      });

      // 更新activeTab
      if (maxEntry && activeTab.value !== maxEntry.target.id) {
        activeTab.value = maxEntry.target.id;
        history.replaceState(null, "", `#${maxEntry.target.id}`);
      }
    },
    {
      root: null,
      rootMargin: "-80px 0px -50% 0px",
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    },
  );

  const sections = ["background", "challenges", "scenarios", "architecture", "advantages", "cases"];
  sections.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      navObserver.value.observe(element);
    }
  });
};

onMounted(() => {
  // 刷新页面时去除hash值并回到顶部，默认高亮"业务挑战"选项
  history.replaceState(null, "", window.location.pathname);
  window.scrollTo(0, 0);
  activeTab.value = "background";

  setTimeout(() => {
    setupIntersectionObserver();

    animationObserver.value = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targetId = entry.target.id;
            if (targetId === "background") backgroundVisible.value = true;
            if (targetId === "challenges") challengesVisible.value = true;
            if (targetId === "scenarios") scenariosVisible.value = true;
            if (targetId === "architecture") architectureVisible.value = true;
            if (targetId === "advantages") advantagesVisible.value = true;
            if (targetId === "cases") casesVisible.value = true;
          }
        });
      },
      { threshold: 0.1, rootMargin: "-10% 0px -10% 0px" },
    );

    document.querySelectorAll(".ai-platform-block").forEach((block) => {
      animationObserver.value.observe(block);
    });
  }, 300);

  // 添加滚动事件监听器作为备用方案
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("scroll", handleScrollImmediate, { passive: true });
});

onBeforeUnmount(() => {
  // 清理IntersectionObserver
  if (navObserver.value) {
    navObserver.value.disconnect();
  }

  // 清理动画观察器
  if (animationObserver.value) {
    animationObserver.value.disconnect();
  }

  // 移除滚动事件监听器
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("scroll", handleScrollImmediate);
});
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: var(--color-text);
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s ease;
}

.background-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.case-content {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
}

.section-content-cases {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(6, 85, 159, 0); }
  50% { opacity: 0.88; box-shadow: 0 0 28px rgba(6, 85, 159, 0.25); }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
}

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    110deg,
    #eaf2ff 0%,
    #f7fbff 40%,
    #eef5ff 60%,
    #dfeaff 100%
  );
  overflow: hidden;
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      1200px 360px at 75% 20%,
      rgba(24, 144, 255, 0.18) 0%,
      rgba(24, 144, 255, 0) 60%
    ),
    radial-gradient(
      800px 300px at 20% 80%,
      rgba(64, 158, 255, 0.2) 0%,
      rgba(64, 158, 255, 0) 60%
    );
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.top_img {
  transition: opacity 0.5s ease;
  opacity: 0;
}

.top_img.show {
  opacity: 1;
}

.block {
  scroll-margin-top: 120px;
  max-width: 1420px;
  margin: 0 auto;
  padding: 60px 20px 90px 20px;
}


.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon {
  flex-shrink: 0;
}
.card-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.card-title {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #000000;
  line-height: 40px;
}
.card-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

.scenarios {
  display: flex;
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  padding: 50px 0px 0px 40px;
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item {
  margin-bottom: 18px;
}
.scenario-item .item-title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFang SC;
}
.scenario-item .item-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.diagram {
  text-align: center;
}
.diagram img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

#advantages {
  background: linear-gradient(180deg, #f5f7fa 0%, #e0ecff 100%);
  max-width: unset;
}

.advantages .grid-4 {
  align-items: stretch;
  gap: 20px;
  max-width: 1416px;
  margin: 0 auto;
}

.adv-card {
  min-height: 240px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 29px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
}

.adv-badge {
  position: absolute;
  top: 33px;
  left: 29px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #1890ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

.adv-title {
  font-size: 16px;
  font-family: PingFang SC;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.adv-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.main-content {
  background: #fff;
}

#scenarios {
  max-width: unset;
  background: #f5f7fa;
}

@media (max-width: 1200px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .product-body {
    padding: 0 16px 40px;
  }
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4 {
    grid-template-columns: 1fr;
  }
  .product-tabs-bar {
    gap: 16px;
  }
  .product-tabs-bar a {
    font-size: 13px;
  }
  .scenario-image {
    width: 100%;
    height: 280px;
  }
  .scenario-text {
    height: auto;
    border-radius: 6px;
  }
}

@media (max-width: 576px) {
  .product-tabs-bar {
    gap: 20px;
  }
}
</style>
